export default "/images/96a9ceec228683001ecd8d344b45f38e.png";